import DashboardLayoutAdmin from "@/layout/dashboard/DashboardLayout.vue";
import DashboardLayoutUser from "@/layout/dashboard/DashboardLayoutUser.vue";
import DashboardAdmin from "@/pages/Dashboard.vue";
import DashboardUser from "@/pages/DashboardUser.vue";
import Notifications from "@/pages/Notifications.vue";

import Login from "@/views/login/login_index.vue";
import Email from "@/views/forgot_password/email.vue";
import Success from "@/views/forgot_password/Success.vue";
import ChangePassword from "@/views/forgot_password/changePassword.vue";
import NotFound from "@/pages/NotFoundPage.vue";
import Changelog from "@/views/changelog/index.vue";

//ADMIN
import UserManagement from "@/views/admin/user_management/user_index";
import CreateUserManagement from "@/views/admin/user_management/user_create.vue";
import UpdateUserManagement from "@/views/admin/user_management/user_update.vue";
import ViewUserManagement from "@/views/admin/user_management/user_view.vue";
import Stockout from "@/views/admin/stockout/stockout_index";
import DeliveryOrder from "@/views/admin/delivery_order/do_index";
import PurchaseOrder from "@/views/admin/purchase_order/po_index";
import MonthlyForecast from "@/views/admin/monthly_forecast/mf_index";
import StockoutChanges from "@/views/admin/stockout_changes/stockoutChanges_index";
import StockoutChangesReview from "@/views/admin/stockout_changes/stockoutChanges_review";
import Outlet from "@/views/admin/outlet/outlet_index.vue";
import Setting from "@/views/admin/setting/setting_index.vue";
import Product from "@/views/admin/product/product_index.vue";
import CreateProduct from "@/views/admin/product/product_create.vue";
import UpdateProduct from "@/views/admin/product/product_update.vue";
import ViewProduct from "@/views/admin/product/product_view.vue";
import ChangePW from "@/views/admin/user_management/ChangePW.vue";
import SubDealerAdmin from "@/views/admin/subdealer/SubDealerIndex.vue";
import SubDealerAdminView from "@/views/admin/subdealer/SubDealerView.vue";
import SubDealerAdminView2 from "@/views/admin/subdealer/SubDealerView2.vue";
import AuditTrail from "@/views/admin/AuditTrail.vue";


//USER
import PurchaseOrderUser from "@/views/user/purchase_order/po_index";
import ViewPurchaseOrderUser from "@/views/user/purchase_order/view_po";
import CreatePurchaseOrderUser from "@/views/user/purchase_order/po_create";
import PreviewPurchaseOrderUser from "@/views/user/purchase_order/po_preview";
import DeliveryOrderUser from "@/views/user/delivery_order/do_index";
import ViewDeliveryOrderUser from "@/views/user/delivery_order/view_do";
import CreateDeliveryOrder from "@/views/user/delivery_order/do_create";
import SubmittedDeliveryOrder from "@/views/user/delivery_order/do_submitted";
import SubDealer from "@/views/user/sub_dealer/subdealer_index";
import SubDealerView from "@/views/user/sub_dealer/subdealer_view";
import SubDealerNext from "@/views/user/sub_dealer/subdealer_next";
import SubDealerStockoutView from "@/views/user/sub_dealer/subdealer_stockout";
import StockoutByDayView from "@/views/user/sub_dealer/stockoutByDayView";
import StockoutChangesUser from "@/views/user/stockout_changes/stockoutChanges_index";
import StockoutChangesReviewUser from "@/views/user/stockout_changes/stockoutChanges_review";
import MonthlyForecastUser from "@/views/user/monthly_forecast/monthlyForecast_index";
import MonthlyForecastUserView from "@/views/user/monthly_forecast/monthlyForecast_view";
import MonthlyForecastUserEdit from "@/views/user/monthly_forecast/monthlyForecast_edit";
import MonthlyForecastUserSubmit from "@/views/user/monthly_forecast/monthlyForecast_submit";
import StockoutUser from "@/views/user/stockout/stockout_index.vue";
import StockoutUserView from "@/views/user/stockout/stockout_view.vue";
import StockoutUserCreate from "@/views/user/stockout/stockout_create.vue";
import StockoutUserSubmit from "@/views/user/stockout/stockout_submit.vue";
import SettingUser from "@/views/user/setting/setting_user.vue";
import StockoutChange from "@/views/user/stockout/stockout_change.vue";
import POChanges from "@/views/user/purchase_order/po_changes.vue";
import DOChanges from "@/views/user/delivery_order/do_changes.vue";
import MFChanges from "@/views/user/monthly_forecast/mf_changes.vue";
import OutletHistoryName from "@/views/user/outlet_name_history/outlet_name_history_index";

import Logout from "@/views/Logout.vue";

//----------- ADMIN -----------
const routes = [
  {
    path: "/",
    component: DashboardLayoutAdmin,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: DashboardAdmin
      },
      {
        path: "stockout",
        name: "stockout",
        component: Stockout
      },
      {
        path: "/stockout/viewstockout",
        name: "stockout",
        // url: `admin/stockout/stockoutInvoice/${stock_id}`,
        component: StockoutUserView
      },
      {
        path: "notifications",
        name: "notifications",
        component: Notifications
      },
      {
        path: "setting",
        name: "Setting",
        component: Setting
      },
      {
        path: "outlet",
        name: "Outlet",
        component: Outlet
      },
      {
        path: "stockout_changes",
        name: "Stockout Changes",
        component: StockoutChanges
      },
      {
        path: "stockout_changes_review",
        name: "Stockout Changes Review",
        component: StockoutChangesReview
      },
      {
        path: "user_management",
        name: "user management",
        component: UserManagement
      },
      {
        path: "user_create",
        name: "create user management",
        component: CreateUserManagement
      },
      {
        path: "user_update",
        name: "Update user management",
        component: UpdateUserManagement
      },
      {
        path: "user_view",
        name: "user management",
        component: ViewUserManagement
      },
      {
        path: "changepw_user",
        name: "Change Password User",
        component: ChangePW
      },
      {
        path: "delivery_order",
        name: "delivery order",
        component: DeliveryOrder
      },
      {
        path: "viewDO",
        name: "delivery order",
        component: ViewDeliveryOrderUser
      },
      {
        path: "purchase_order",
        name: "purchase order",
        component: PurchaseOrder
      },
      {
        path: "viewPO",
        name: "purchase order",
        component: ViewPurchaseOrderUser
      },
      {
        path: "monthly_forecast",
        name: "monthly forecast",
        component: MonthlyForecast
      },
      {
        path: "viewMF",
        name: "Monthly Forecast",
        component: MonthlyForecastUserView
      },
      {
        path: "product",
        name: "Product",
        component: Product
      },
      {
        path: "createProduct",
        name: "Create Product",
        component: CreateProduct
      },
      {
        path: "updateProduct",
        name: "Update Product",
        component: UpdateProduct
      },
      {
        path: "viewProduct",
        name: "Product",
        component: ViewProduct
      },
      {
        path: "home_dealer_admin",
        name: "Home Dealer Admin",
        component: SubDealerAdmin
      },
      {
        path: "home_dealer_admin_view",
        name: "Home Dealer Admin View",
        component: SubDealerAdminView
      },
      {
        path: "home_dealer_admin_next",
        name: "Sub Dealer Admin Next",
        component: SubDealerAdminView2
      },
      {
        path: "stockout_view_admin",
        name: "Stockout View",
        component: StockoutUserView
      },
      {
        path: "audit_trail",
        name: "Audit Trail",
        component: AuditTrail
      }
    ]
  },
  //================ USER ==============
  {
    path: "/",
    component: DashboardLayoutUser,
    meta: {
      requiresAuthUser: true
    },
    children: [
      {
        path: "dashboardUser",
        name: "dashboardUser",
        component: DashboardUser
      },
      {
        path: "stockout_user",
        name: "stockout",
        component: StockoutUser
      },
      {
        path: "stockout_user_view",
        name: "stockout",
        component: StockoutUserView
      },
      {
        path: "stockout_user_create",
        name: "stockout",
        component: StockoutUserCreate
      },
      {
        path: "stockout_user_submit",
        name: "stockout",
        component: StockoutUserSubmit
      },
      {
        path: "notifications",
        name: "notifications",
        component: Notifications
      },
      {
        path: "setting",
        name: "Setting",
        component: Setting
      },
      {
        path: "stockout_changes_user",
        name: "Stockout Changes",
        component: StockoutChangesUser
      },
      {
        path: "stockout_changes_review_user",
        name: "Stockout Changes Review",
        component: StockoutChangesReviewUser
      },
      {
        path: "sub_dealer_user",
        name: "Sub Dealer",
        component: SubDealer
      },
      {
        path: "stockout_view_user",
        name: "Sub Dealer",
        component: StockoutUserView
      },
      {
        path: "subdealer_user",
        name: "Sub Dealer",
        component: SubDealerView
      },
      {
        path: "subdealer_next",
        name: "Sub Dealer",
        component: SubDealerNext
      },
      {
        path: "subDealerStockoutView",
        name: "Sub Dealer",
        component: SubDealerStockoutView
      },
      {
        path: "StockoutByDayView",
        name: "Sub Dealer",
        component: StockoutByDayView
      },
      {
        path: "delivery_order_user",
        name: "delivery order",
        component: DeliveryOrderUser
      },
      {
        path: "viewDOUser",
        name: "view delivery order",
        component: ViewDeliveryOrderUser
      },
      {
        path: "createdo",
        name: "create delivery order",
        component: CreateDeliveryOrder
      },
      {
        path: "doSubmitted",
        name: "delivery order submitted",
        component: SubmittedDeliveryOrder
      },
      {
        path: "purchase_order_user",
        name: "purchase order",
        component: PurchaseOrderUser
      },
      {
        path: "viewPOUser",
        name: "view purchase order",
        component: ViewPurchaseOrderUser
      },
      {
        path: "createPO",
        name: "create purchase order",
        component: CreatePurchaseOrderUser
      },
      {
        path: "previewPO",
        name: "preview purchase order",
        component: PreviewPurchaseOrderUser
      },
      {
        path: "mf_user",
        name: "monthly forecast",
        component: MonthlyForecastUser
      },
      {
        path: "mf_view",
        name: "Monthly Forecast",
        component: MonthlyForecastUserView
      },
      {
        path: "mf_edit",
        name: "Monthly Forecast",
        component: MonthlyForecastUserEdit
      },
      {
        path: "mf_submit",
        name: "Monthly Forecast",
        component: MonthlyForecastUserSubmit
      },
      {
        path: "settingUser",
        name: "Setting",
        component: SettingUser
      },
      {
        path: "/change_stockout",
        name: "Change Stockout",
        component: StockoutChange
      },
      {
        path: "/change_po",
        name: "Change PO",
        component: POChanges
      },
      {
        path: "/change_do",
        name: "Change MF",
        component: DOChanges
      },
      {
        path: "/change_mf",
        name: "Change MF",
        component: MFChanges
      },
      {
        path: "/outlet_history_name_user",
        name: "OUTLET NAME HISTORY",
        component: OutletHistoryName
      }
    ]
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
    meta: {
      requiresAuthUser: true
    }
  },
  {
    path: "/changelog",
    component: Changelog,
    name: "changelog",
    meta: {
      requiresVisitor: true
    }
  },
  {
    path: "/login",
    component: Login,
    name: "login",
    meta: {
      requiresVisitor: true
    }
  },
  {
    path: "/email",
    name: "email",
    component: Email,
    meta: {
      requiresVisitor: true
    }
  },
  {
    path: "/changePassword",
    name: "changePassword",
    component: ChangePassword,
    meta: {
      requiresVisitor: true
    }
  },
  {
    path: "/success",
    name: "success",
    component: Success,
    meta: {
      requiresVisitor: true
    }
  },
  { path: "*", component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
